import { FC } from "react";
import clsx from "clsx";
import { getIconPath } from "@/utils/helpers";
import { Card } from "../../shared/ui/card/Card";
import { AnalystForecasts } from "./analyst-forecasts-section/AnalystForecasts";
import { AnalystRatings } from "./analyst-ratings-section";
//import { MonthForecast } from "./month-forecast-section";
import { BestAnalysts } from "./best-analysts-section/BestAnalysts";
import { TopAnalystConsensusStocks } from "./top-stocks-section";
//import { FinancialForecast } from "./financial-forecast-section/FinancialForecast";
import { useUI } from "@/redux/selectors/uiSelector";
//import { useSymbolAnalystForecasts } from "../hooks/useSymbolAnalystForecasts";
import { AnalyticsLoader } from "../../shared/ui/loader/AnalyticsLoader";
import styles from "./AnalystForecastsView.module.scss";
import { Scrollbar } from "react-scrollbars-custom";
import { StockOverview } from "./stock-overview/StockOverview";
import { Insiders } from "./insiders/Insiders";
import { Hedgefunds } from "./hedgefunds/Hedgefunds";
import { useTranslation } from "next-i18next";
export const ForecastHeader = ({
    ticker,
    tickerLabel,
    //theme,
}: {
    ticker: string;
    tickerLabel: string;
    //theme: "light" | "dark";
}) => {
    const { t } = useTranslation("common");
    return (
        <header className={styles.forecastHeader}>
            <h1 className={styles.forecastTitle}>
                {t("analytics.analystForecasts.header.title", { ticker, tickerLabel })}
            </h1>
            <div className={styles.poweredBy}>
                <span>{t("analytics.analystForecasts.header.poweredBy")}</span>
                <img
                    src={getIconPath({
                        name: `/analytics/tipRanks`, //_${theme}`,
                        ext: "svg",
                    })}
                    alt={t("analytics.analystForecasts.header.tipranksAlt")}
                />
            </div>
        </header>
    );
};

interface IAnalystForecastsViewProps {
    isActive: boolean;
    ticker: string;
    tickerLabel: string;
    isExpanded: boolean;
    data;
    isLoading;
}

export const AnalystForecastsView: FC<IAnalystForecastsViewProps> = ({
    ticker,
    tickerLabel,
    isExpanded,
    data,
    isLoading,
}) => {
    //const { palette } = useTheme();
    const { isTradeOrderViewOpen } = useUI();
    const { t } = useTranslation("common");

    // const { data, isLoading } = useSymbolAnalystForecasts({ ticker });

    const {
        analystForecastsData,
        analystRatingsData,
        bestAnalystsAndTrendsData,
        // financialForecastData,
        // monthForecastData,
        stocksData,
    } = data || {};

    const titles = {
        analystRatings: t("analytics.analystForecasts.cards.analystRatingsTitle", { ticker }),
        analystRatingsTooltip: t("analytics.analystForecasts.cards.analystRatingsTooltip"),
        monthForecast: t("analytics.analystForecasts.cards.monthForecastTitle", { ticker }),
        analystForecasts: t("analytics.analystForecasts.cards.analystForecastsTitle", { ticker }),
        bestAnalysts: t("analytics.analystForecasts.cards.bestAnalystsTitle", { tickerLabel }),
        stocksWithHighestTopAnalystConsensus: t(
            "analytics.analystForecasts.cards.topConsensusStocksTitle"
        ),
        financialForecast: t("analytics.analystForecasts.cards.financialForecastTitle", { ticker }),
    };

    return (
        <div
            className={clsx(styles.forecastSection, {
                [styles.isLoading]: isLoading,
            })}>
            {isLoading ? (
                <AnalyticsLoader />
            ) : (
                <>
                    <ForecastHeader ticker={ticker} tickerLabel={tickerLabel} />
                    <Scrollbar style={{ height: "calc(-200px + 100vh)" }}>
                        <main className={styles.forecastContent}>
                            <div className={styles.gaugesWrapper}>
                                <StockOverview ticker={ticker} />
                                <Hedgefunds ticker={ticker} />
                                <Insiders ticker={ticker} />
                            </div>
                            <Card title={titles.bestAnalysts}>
                                {bestAnalystsAndTrendsData && (
                                    <BestAnalysts {...bestAnalystsAndTrendsData} ticker={ticker} />
                                )}
                            </Card>
                            {!!stocksData?.length && (
                                <Card
                                    title={titles.stocksWithHighestTopAnalystConsensus}
                                    withInfoIcon={false}>
                                    <TopAnalystConsensusStocks
                                        data={stocksData}
                                        isTradeOrderViewOpen={isTradeOrderViewOpen}
                                    />
                                </Card>
                            )}
                            <Card title={titles.analystForecasts}>
                                {analystForecastsData && <AnalystForecasts {...analystForecastsData} />}
                            </Card>
                            <div
                                className={clsx(styles.forecastChartsRow, {
                                    [styles.isExpanded]: isExpanded,
                                })}>
                                <Card
                                    title={titles.analystRatings}
                                    tooltipText={titles.analystRatingsTooltip}>
                                    {analystRatingsData && <AnalystRatings {...analystRatingsData} />}
                                </Card>
                                {/* <Card title={titles.monthForecast}>
                                {monthForecastData && (
                                    <MonthForecast {...monthForecastData} isExpanded={isExpanded} />
                                )}
                            </Card> */}
                            </div>
                            {/* <Card title={titles.financialForecast} withInfoIcon={false}>
                            {financialForecastData && (
                                <FinancialForecast {...financialForecastData} ticker={ticker} />
                            )}
                        </Card> */}
                        </main>
                    </Scrollbar>
                </>
            )}
        </div>
    );
};
